import { render, staticRenderFns } from "./WxpaySubMerchantApply.vue?vue&type=template&id=39b770f1&scoped=true&"
import script from "./WxpaySubMerchantApply.vue?vue&type=script&lang=js&"
export * from "./WxpaySubMerchantApply.vue?vue&type=script&lang=js&"
import style0 from "./WxpaySubMerchantApply.vue?vue&type=style&index=0&id=39b770f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b770f1",
  null
  
)

export default component.exports